"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DIALOG_SIZES = void 0;
const DIALOG_SIZES = exports.DIALOG_SIZES = ['xl', 'lg', 'md', 'sm'];